// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2FgIA","header":"ClearentDisclaimer_header__N-ce9","inner":"ClearentDisclaimer_inner__1UUEG"};